import { useMemo } from 'react';

export const useHasBenefitTag = (
  benefitTags: { tagName: string }[] | undefined,
  expectedTag: string,
) => {
  return useMemo(() => {
    if (!benefitTags) return false;

    return !!benefitTags?.some(({ tagName }: { tagName: string }) => {
      return tagName === expectedTag;
    });
  }, [benefitTags, expectedTag]);
};
